import { slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useBlockEnvironment } from '@zillow/cms-blocks/BlockEnvironment';
import { Box, FormField, Label, FormHelp, Input } from '@zillow/constellation';
import PropertySearch from '@zillow/property-search';
import React, { useState } from 'react';

var PROPERTY_SEARCH_CONFIG_VALUES = {
  prod: {
    addressAutocompleteURL: 'https://www.zillowstatic.com/autocomplete/v3/suggestions/'
  },
  test: {
    addressAutocompleteURL: 'https://static.qa.zillow.net/autocomplete/v3/suggestions/'
  }
};
var AddressAutocompleteField = function AddressAutocompleteField(_ref) {
  var _PROPERTY_SEARCH_CONF;
  var onSelect = _ref.onSelect,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Enter the complete property address' : _ref$placeholder,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Property Address' : _ref$label,
    description = _ref.description,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    error = _ref.error,
    onBlur = _ref.onBlur;
  var _useBlockEnvironment = useBlockEnvironment(),
    _useBlockEnvironment$ = _useBlockEnvironment.environment,
    environment = _useBlockEnvironment$ === void 0 ? 'prod' : _useBlockEnvironment$;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    address = _useState2[0],
    setAddress = _useState2[1];

  // Handler for when the address input changes
  var handleChange = function handleChange(value) {
    setAddress(value);
    onSelect(value);
    // Optionally, you could call onSelect here with just the address, but per request, only store it
  };

  // Handler for when an address is selected (submit)
  var handleSubmit = function handleSubmit(selection) {
    var selectedAddress = (selection === null || selection === void 0 ? void 0 : selection.address) || address;
    var zpid = selection === null || selection === void 0 ? void 0 : selection.zpid;
    if (selectedAddress) {
      onSelect(selectedAddress, zpid);
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    marginBottom: "$spacing.sm"
  }, /*#__PURE__*/React.createElement(FormField, {
    error: Boolean(error),
    label: /*#__PURE__*/React.createElement(Label, null, label),
    required: required,
    description: /*#__PURE__*/React.createElement(FormHelp, {
      error: !!error
    }, error || description),
    control: /*#__PURE__*/React.createElement(PropertySearch, {
      renderEmptyState: null,
      renderInput: function renderInput(props) {
        return /*#__PURE__*/React.createElement(Input, _extends({
          required: required,
          error: Boolean(error),
          placeholder: placeholder,
          value: address,
          onChange: function onChange(e) {
            return handleChange(e.target.value);
          },
          onBlur: props.onBlur || onBlur
        }, props));
      },
      addressAutocompleteUrl: (PROPERTY_SEARCH_CONFIG_VALUES === null || PROPERTY_SEARCH_CONFIG_VALUES === void 0 || (_PROPERTY_SEARCH_CONF = PROPERTY_SEARCH_CONFIG_VALUES[environment]) === null || _PROPERTY_SEARCH_CONF === void 0 ? void 0 : _PROPERTY_SEARCH_CONF.addressAutocompleteURL) || PROPERTY_SEARCH_CONFIG_VALUES.prod.addressAutocompleteURL,
      onChange: handleChange,
      onSubmit: handleSubmit
    })
  }));
};
var AddressAutocompleteField$1 = AddressAutocompleteField;

export { AddressAutocompleteField$1 as default };
